import React from "react";
import ReactDOM from "react-dom";

// import Portal from '@chiron/portal';
import { NotificationWorkspace } from "@chiron/subscription-notification";
// import {StudentPortfolio, OriginalStudentPortfolio} from '@chiron/student-portfolio';
// import MaintenanceSplash from '@chiron/maintenance-splash';
import StudentPortal from "@chiron/student-portal";
// import DocViewer from '@chiron/doc-viewer';
// import RegPortal from '@chiron/reg-portal';
// import Example from '@chiron/component-template';
//import Crmgr from '@chiron/crmgr';
//import PeakTable from '@chiron/peak-table';
//import LabCrmgr from '@chiron/student-crmgr';
//import Contracts from '@chiron/contracts';
//import ChironAppBar from '@chiron/appbar';
//import '/node_modules/react-grid-layout/css/styles.css'
//import '/node_modules/react-resizable/css/styles.css'
import "./styles.css";
import "../node_modules/react-grid-layout/css/styles.css";
import "../node_modules/react-resizable/css/styles.css";
//var tabs = [{label: "Contracts", routeName:"contracts", routeType:"public", routeAccess:"", tabPanelJSX:(<Contracts/>)}];

ReactDOM.render(
  <React.StrictMode>
    <StudentPortal />
  </React.StrictMode>,
  document.getElementById("root"),
);
